<template>
    <v-app>
        <v-navigation-drawer
            v-model="drawer"
            app :temporary="$vuetify.breakpoint.xs"
            dark
            width="300"
        >
            <div class="background-absolute"></div>
            <v-img src="@/assets/img/logo+text_dark.svg" height="100px" contain class="ma-4 my-12"></v-img>
            <div class="text-center mb-8">
                <LanguageElement></LanguageElement>
            </div>
            <v-divider></v-divider>
            <v-list tile dense class="text-uppercase main-font">
                <v-list-item
                    v-for="route in drawerRoutes"
                    :key="route.name"
                    link
                    :to="route.name"
                    class="mx-2 my-1"
                >
                    <v-list-item-icon>
                        <v-icon small>{{ route.meta.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t("pages." + route.name + ".title") }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <template v-slot:append>
                <v-list tile dense class="text-uppercase">
                    <v-list-item
                        v-if="!$store.state.user"
                        @click="$root.dialogs.login.open()"
                        class="mx-2 my-1"
                    >
                        <v-list-item-icon>
                            <v-icon small>mdi-login</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ $t("session.login.text") }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                        v-else
                        @click="$root.dialogs.login.logout()"
                        class="mx-2 my-1"
                    >
                        <v-list-item-icon>
                            <v-icon small>mdi-logout</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ $t("session.logout.text") }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </template>
        </v-navigation-drawer>
        <v-main v-if="visible" class="white">
            <v-app-bar
                v-if="$vuetify.breakpoint.smAndDown"
                app height="120px" color="secondary"
                dark
            >
                <v-app-bar-nav-icon @click="drawer = !drawer" tile></v-app-bar-nav-icon>
                <v-spacer></v-spacer>
                <v-app-bar-title>
                    <router-link to="/">
                        <v-img src="@/assets/img/text_dark.svg" height="auto" width="180px" contain></v-img>
                    </router-link>
                </v-app-bar-title>
                <v-spacer></v-spacer>
                <LanguageElement icon></LanguageElement>
            </v-app-bar>
            <router-view></router-view>
        </v-main>
        <v-footer v-if="visible" padless absolute app inset dark>
            <v-row class="main-font white" no-gutters>
                <v-col cols="12" class="secondary py-12">
                    <v-row no-gutters>
                        <v-col
                            cols="12"
                            class="headline text-center text-uppercase mb-2"
                        >
                            <span class="main-font">
                                <v-icon left>mdi-clock-check-outline</v-icon>
                                {{ $t("opening-hours.title") }}
                            </span>
                        </v-col>
                        <v-col
                            cols="12"
                            class="title text-center"
                        >
                            <span class="secondary-font">
                                <div
                                    v-for="(oh, i) in $t('opening-hours.items')"
                                    :key="i"
                                    class="my-2"
                                >
                                    {{ oh.dow }} <v-chip color="primary" label class="main-font">{{ oh.time }}</v-chip>
                                </div>
                            </span>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" id="footer-info" :class="{ 'small': $vuetify.breakpoint.mdAndDown }">
                    <v-row no-gutters justify="center">
                        <v-col cols="12" md="7" lg="3" align="center" align-self="center" class="pa-6">
                            <div class="mb-4 subtitle primary--text text">
                                <v-icon left color="primary">mdi-arrow-down</v-icon>
                                {{ $t("call-us") }}
                                <v-icon right color="primary">mdi-arrow-down</v-icon>
                            </div>
                            <v-btn
                                :href="'tel:' + _env.VUE_APP_PHONE" target="_blank"
                                tile block color="primary" class="text-wrap pa-8"
                            >
                                <v-icon size="24" left>mdi-phone</v-icon>
                                <span class="font-weight-bold title">
                                    {{ _env.VUE_APP_PHONE }}
                                </span>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" md="7" lg="3" align="center" align-self="center" class="pa-6">
                            <v-avatar
                                size="256"
                            >
                                <v-img src="/assets/img/gallery/13.jpg"></v-img>
                            </v-avatar>
                        </v-col>
                        <v-col cols="12" md="7" lg="3" align="center" align-self="center" class="pa-6">
                            <div class="mb-4 subtitle primary--text text">
                                <v-icon left color="primary">mdi-arrow-down</v-icon>
                                {{ $t("visit-us") }}
                                <v-icon right color="primary">mdi-arrow-down</v-icon>
                            </div>
                            <v-btn
                                :href="_env.VUE_APP_ADDRESS_LINK" target="_blank"
                                tile block color="primary" class="pa-8 text-wrap"
                            >
                                <v-icon size="24" left>mdi-map-marker</v-icon>
                                <span class="font-weight-bold subtitle">
                                    {{ _env.VUE_APP_ADDRESS }}
                                </span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12">
                    <v-row no-gutters class="py-2 accent text-caption">
                        <v-col cols="12" class="secondary-font text-center">
                            &copy; {{ new Date().getFullYear() }} {{ _env.VUE_APP_TITLE }} — {{ $t("copyright") }}
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-footer>
        <SplashDialog @enter="updateSplash()"></SplashDialog>
        <LoginDialog ref="loginDialog"></LoginDialog>
        <SnackElement ref="snackElement"></SnackElement>
        <ImageCarouselOverlay
            :value="promos.overlay"
            :images="promos.images"
            @close="promos.overlay = false"
            path="./uploads/"
            cycle
        ></ImageCarouselOverlay>
    </v-app>
</template>

<script>
    import SplashDialog from "./dialogs/Splash";
    import LoginDialog from "./dialogs/Login";
    import SnackElement from "./elements/Snack";
    import LanguageElement from "./elements/Language";
    import ImageCarouselOverlay from "@/components/elements/ImageCarouselOverlay";

    export default {
        name: "app",
        components: {
            SplashDialog, LoginDialog, SnackElement, LanguageElement,
            ImageCarouselOverlay
        },
        data: () => ({
            visible: false,
            drawer: true,
            login: false,

            links: [
                { icon: "mdi-twitter", text: "Twitter", value: "https://x.com/spazephyr" },
                { icon: "mdi-instagram", text: "Instagram", value: "https://instagram.com/spazephyr" }
            ],

            promos: {
                overlay: false,
                images: []
            }
        }),
        watch: {
            "$route": function(newValue, oldValue) {
                console.log("$route watcher, ", "to:", oldValue.name, "from:", newValue.name);
                window.scrollTo(0, 0);
            }
        },
        computed: {
            drawerRoutes() {
                return this.$router.options.routes.filter(route => !!route.meta);
            }
        },
        methods: {
            updateSplash() {
                this.visible = true;

                // fetch and show promos
                this._request("promotions/get-all", { home: true }).then(response => {
                    if(!response.images || response.images.length == 0) {
                        this.promos.images = [];
                        return;
                    }
                    this.promos.images = response.images;
                    this.promos.overlay = true;
                });

                // update page for schedule on mobile only
                if(this.$vuetify.breakpoint.smAndDown) {
                    this.$router.push({ name: 'schedule' });
                }
            }
        },
        created() {
            // check session
            this._request("users/session").then(response => {
                if(!response.user) {
                    return;
                }
                this.$store.commit({ type: "setUser", user: response.user });
            });
            this.drawer = this.$vuetify.breakpoint.name != "xs" && this.$vuetify.breakpoint.name != "sm";
        },
        mounted() {
            this.$root.dialogs = {
                login: this.$refs.loginDialog
            };
            this.$root.snack = this.$refs.snackElement;
        }
    };
</script>

<style>
    @font-face {
        font-family: 'Metropolis-Regular';
        src: url('@/assets/fonts/Metropolis-Regular.otf') format('opentype');
    }
    @font-face {
        font-family: 'Metropolis-Bold';
        src: url('@/assets/fonts/Metropolis-Bold.otf') format('opentype');
    }
    /*@font-face {
        font-family: 'Metropolis-Thin';
        src: url('@/assets/fonts/Metropolis-Thin.otf') format('opentype');
    }*/
    .main-font {
        font-family: 'Metropolis-Bold' !important;
    }
    .secondary-font {
        font-family: 'Metropolis-Regular' !important;
    }
    body {
        font-family: 'Metropolis-Regular' !important;
        font-weight: 300 !important;
    }

    .background-absolute {
        z-index: 0;
        position: absolute;
        top: 0px; bottom: 0px; left: 0px; right: 0px;
    }
    .background {
        position: relative;
    }
    .background::after, .background-absolute::after {
        z-index: 1;

        content: "";
        position: absolute;
        top: 0px; bottom: 0px; left: 0px; right: 0px;
        opacity: 1;

        background: linear-gradient(#316f9b 0%, #0481a9 50%);
        background-color: #000;
    }
    .background > *, .background-absolute > * {
        z-index: 3;
    }
    .payments {
        display: inline-block;
        height: auto;
        width: 120px;
    }
    #footer-info {
        background: linear-gradient(transparent 20%, #158ab9 140%);
    }
    #footer-info.small {
        background: radial-gradient(transparent 20%, #158ab9 140%);
    }
    #footer-info .text {
        text-shadow: 0px 0px 4px #fff;
    }
</style>